// O ENDEREÇO DE UM CARD DO FUNIL (06/10/2026).
//
// A ficha do card mora em `/pipeline/:pipelineSlug/:view/:itemId` — o funil
// faz parte do caminho. Três lugares montavam esse endereço cada um do seu
// jeito, e dois erravam: a aba Funil da ficha do contato mandava para
// `/pipeline?card=ID` (ninguém lê `card`; abria o quadro sem o card) e o
// "card relacionado" pedia a rota sem o funil (a rota recusava e a página
// recarregava inteira em `/pipeline/items/ID`, que nem existe).
//
// Só o número no começo do `pipelineSlug` importa para a tela
// (`extractIdFromSlug`); o nome depois do número é para quem lê a barra.
export const slugDoFunil = (funil, id) => {
  const numero = funil?.id ?? id;
  if (!numero) return null;
  const nome = (funil?.name || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
  return nome ? `${numero}-${nome}` : String(numero);
};

// Sem o funil (não veio do servidor), o melhor lugar é o quadro do funil.
export const rotaDoCard = ({ accountId, funil, funilId, itemId }) => {
  const pipelineSlug = slugDoFunil(funil, funilId);
  if (!pipelineSlug) return { name: 'pipeline_index', params: { accountId } };
  return {
    name: 'pipeline_item_detail',
    params: { accountId, pipelineSlug, view: 'item', itemId },
  };
};
